export default "__VITE_ASSET__BIokLESY__"